// In-memory ring buffer that wraps console.error, window.onerror, and
// window.onunhandledrejection so we can attach the last 30 errors to a
// feedback submission. Initialized from main.jsx exactly once at boot.

const MAX = 30;
const buffer = [];

function push(line) {
  if (!line) return;
  buffer.push({ at: new Date().toISOString(), msg: String(line).slice(0, 1000) });
  while (buffer.length > MAX) buffer.shift();
}

let installed = false;
export function initConsoleErrorBuffer() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const origError = console.error.bind(console);
  console.error = (...args) => {
    try {
      const parts = args.map((a) => {
        if (a instanceof Error) return `${a.name}: ${a.message}`;
        if (typeof a === 'string') return a;
        try { return JSON.stringify(a); } catch { return String(a); }
      });
      push(parts.join(' '));
    } catch { /* never break the original console.error */ }
    origError(...args);
  };

  window.addEventListener('error', (ev) => {
    push(`window.error: ${ev?.message || ''} @ ${ev?.filename || ''}:${ev?.lineno || ''}`);
  });
  window.addEventListener('unhandledrejection', (ev) => {
    const reason = ev?.reason;
    const msg = reason instanceof Error ? `${reason.name}: ${reason.message}` : String(reason);
    push(`unhandledRejection: ${msg}`);
  });
}

export function getRecentConsoleErrors() {
  return buffer.map((b) => `[${b.at}] ${b.msg}`);
}

// Drop any captured errors. Call from logout so a logged-out user's
// console state can't bleed into the next user's first feedback submission.
export function clearConsoleErrorBuffer() {
  buffer.length = 0;
}
